<template>
  <span
    class="notranslate currency-to-update"
    :data-usd="totalUSD"
    v-html="total"
  />
</template>

<style scoped>
</style>

<script>
import CurrencyApi from './currency-api.js'

export default {
  props: ['amount', 'currency', 'usd'],
  data: function() {
    return {
      total: '',
      locale: 'en-US'
    }
  },

  computed: {
    totalUSD() {
      return this.usd
    }
  },

  watch: {
    amount() {
      this.setCurrency()
    },
    currency() {
      this.setCurrency()
    }
  },
  created() {
    this.locale = navigator.language || 'en-US'
    this.setCurrency()
  },
  methods: {
    setCurrency() {
      var total = Number(this.amount).toFixed(2)
      if (this.currency == 'USD') {
        this.total = '$' + total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        this.total = CurrencyApi.formatAmount(total, this.currency)
      }
    }
  }
}
</script>
